import {qspost} from '@/plugins/axios'

/*
 * 手表居民信息列表
 * @constructor jack
 * */
export const getWatchPeople = (name, phone, xiangmu_id, xiaoqu_id, lou_id, men_id, hu_id, page, pageSize) => qspost('/Index/Save/getWatchPeople', {
    name,
    phone,
    xiangmu_id,
    xiaoqu_id,
    lou_id,
    men_id,
    hu_id,
    page,
    pageSize
})


/*
 *更新居民信息 -- 病情信息
 * @constructor jack
 * */
export const saveJuminIll = (jumin_id,ill_id,time_long,medicine_name,id) => qspost('/Index/Save/saveJuminIll', {jumin_id,ill_id,time_long,medicine_name,id})

/*
 *更新居民信息 -- 病情信息
 * @constructor jack
 * */
export const getJuminIllList = (jumin_id) => qspost('/Index/Save/getJuminIllList', {jumin_id})









/*
 * 解绑设置
 * @constructor jack
 * */
export const delEquipment = (jumin_id) => qspost('/Index/Save/delEquipment', {jumin_id})


/*
 * 绑定设置
 * @constructor jack
 * */
export const bdingEquipment = (jumin_id,IMEI,name) => qspost('/Index/Save/bdingEquipment', {jumin_id,IMEI,name})

/*
 * 获取居民详情
 * @constructor jack
 * */
export const getWatchPeopleDetail = (jumin_id) => qspost('/Index/Save/getWatchPeopleDetail', {jumin_id})

/*
 *更新居民信息 -- 紧急联系人
 * @constructor jack
 * */
export const updateWatchPeopleDetail1 = (jumin_id,emergency_contact) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,emergency_contact})


/*
 * 更新居民信息 -- 专业人员
 * @constructor jack
 * */
export const updateWatchPeopleDetail2 = (jumin_id,exclusive_personnel_id) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,exclusive_personnel_id})

/*
 * 更新居民信息 -- 管家
 * @constructor jack
 * */
export const updateWatchPeopleDetail3 = (jumin_id,admin_id) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,admin_id})


/*
 * 更新居民信息 -- 五脏筛查
 * @constructor jack
 * */
export const updateWatchPeopleDetail4 = (jumin_id,wuzang) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,wuzang})

/*
 * 更新居民信息 -- 服务需求情况
 * @constructor jack
 * */
export const updateWatchPeopleDetail5 = (jumin_id,service_demand_situation) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,service_demand_situation})


/*
 * 修改指标
 * @constructor jack
 * */
export const updateWatchPeopleDetail6 = (
    tiwen_value_lower,
    tiwen_value_higher,
    tiwen_warning_value_lower_l,
    tiwen_warning_value_lower_h,
    tiwen_warning_value_higher_l,
    tiwen_warning_value_higher_h,
    tiwen_alarm_value_lower,
    tiwen_alarm_value_higher,
    xinlv_value_lower,
    xinlv_value_higher,
    xinlv_warning_value_lower_l,
    xinlv_warning_value_lower_h,
    xinlv_warning_value_higher_l,
    xinlv_warning_value_higher_h,
    xinlv_alarm_value_lower,
    xinlv_alarm_value_higher,
    xueya_low_alarm_value_lower,
    xueya_low_warning_value_lower_l,
    xueya_low_warning_value_lower_h,
    xueya_low_value_lower,
    xueya_low_value_higher,
    xueya_low_warning_value_higher_l,
    xueya_low_warning_value_higher_h,
    xueya_low_alarm_value_higher,
    xueya_high_alarm_value_lower,
    xueya_high_warning_value_lower_l,
    xueya_high_warning_value_lower_h,
    xueya_high_value_lower,
    xueya_high_value_higher,
    xueya_high_warning_value_higher_l,
    xueya_high_warning_value_higher_h,
    xueya_high_alarm_value_higher,
    xueyang_value_lower,
    xueyang_value_higher,
    xueyang_warning_value_lower_l,
    xueyang_warning_value_lower_h,
    xueyang_warning_value_higher_l,
    xueyang_warning_value_higher_h,
    xueyang_alarm_value_lower,
    xueyang_alarm_value_higher,
    tiwen_warning_lv,
    tiwen_alarm_lv,
    xinlv_warning_lv,
    xinlv_alarm_lv,
    xueya_warning_lv,
    xueya_alarm_lv,
    xueyang_warning_lv,
    xueyang_alarm_lv,
    jumin_id
) => qspost('/Index/Save/updateWatchPeopleDetail', {
    tiwen_value_lower,
    tiwen_value_higher,
    tiwen_warning_value_lower_l,
    tiwen_warning_value_lower_h,
    tiwen_warning_value_higher_l,
    tiwen_warning_value_higher_h,
    tiwen_alarm_value_lower,
    tiwen_alarm_value_higher,
    xinlv_value_lower,
    xinlv_value_higher,
    xinlv_warning_value_lower_l,
    xinlv_warning_value_lower_h,
    xinlv_warning_value_higher_l,
    xinlv_warning_value_higher_h,
    xinlv_alarm_value_lower,
    xinlv_alarm_value_higher,
    xueya_low_alarm_value_lower,
    xueya_low_warning_value_lower_l,
    xueya_low_warning_value_lower_h,
    xueya_low_value_lower,
    xueya_low_value_higher,
    xueya_low_warning_value_higher_l,
    xueya_low_warning_value_higher_h,
    xueya_low_alarm_value_higher,
    xueya_high_alarm_value_lower,
    xueya_high_warning_value_lower_l,
    xueya_high_warning_value_lower_h,
    xueya_high_value_lower,
    xueya_high_value_higher,
    xueya_high_warning_value_higher_l,
    xueya_high_warning_value_higher_h,
    xueya_high_alarm_value_higher,
    xueyang_value_lower,
    xueyang_value_higher,
    xueyang_warning_value_lower_l,
    xueyang_warning_value_lower_h,
    xueyang_warning_value_higher_l,
    xueyang_warning_value_higher_h,
    xueyang_alarm_value_lower,
    xueyang_alarm_value_higher,
    tiwen_warning_lv,
    tiwen_alarm_lv,
    xinlv_warning_lv,
    xinlv_alarm_lv,
    xueya_warning_lv,
    xueya_alarm_lv,
    xueyang_warning_lv,
    xueyang_alarm_lv,
    jumin_id
})



/*
 * 更新居民信息 -- 请选择属性分类
 * @constructor jack
 * */
export const updateWatchPeopleDetail7= (jumin_id,attribute) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,attribute})

/*
 * 更新居民信息 -- 发送短信对象
 * @constructor jack
 * */
export const updateWatchPeopleDetail8= (jumin_id,sms_state) => qspost('/Index/Save/updateWatchPeopleDetail', {jumin_id,sms_state})




/*
 * 专业人员列表
 * @constructor jack
 * */
export const getExclusivePersonnelList = (page, pageSize) => qspost('/Index/Save/getExclusivePersonnelList', {
    page,
    pageSize
})

/*
 * 专业人员添加
 * @constructor jack
 * */
export const saveExclusivePersonnel = (name, phone, id) => qspost('/Index/Save/saveExclusivePersonnel', {
    name,
    phone,
    id
})
/*
 * 删除专业人员
 * @constructor jack
 * */
export const delExclusivePersonnel = (id) => qspost('/Index/Save/delExclusivePersonnel', {id})


/*
 * 专业人员列表
 * @constructor jack
 * */
export const getIllnessList = (page, pageSize) => qspost('/Index/Save/getIllnessList', {page, pageSize})

/*
 * 专业人员添加
 * @constructor jack
 * */
export const saveIllness = (name, id) => qspost('/Index/Save/saveIllness', {name, id})
/*
 * 删除专业人员
 * @constructor jack
 * */
export const delIllness = (id) => qspost('/Index/Save/delIllness', {id})


/*
 * 获取指标
 * @constructor jack
 * */
export const getWarningValue = () => qspost('/Index/Save/getWarningValue', {})



/*
 * 修改指标
 * @constructor jack
 * */
export const saveWarningValue = (
    tiwen_value_lower,
    tiwen_value_higher,
    tiwen_warning_value_lower_l,
    tiwen_warning_value_lower_h,
    tiwen_warning_value_higher_l,
    tiwen_warning_value_higher_h,
    tiwen_alarm_value_lower,
    tiwen_alarm_value_higher,
    xinlv_value_lower,
    xinlv_value_higher,
    xinlv_warning_value_lower_l,
    xinlv_warning_value_lower_h,
    xinlv_warning_value_higher_l,
    xinlv_warning_value_higher_h,
    xinlv_alarm_value_lower,
    xinlv_alarm_value_higher,
    xueya_low_alarm_value_lower,
    xueya_low_warning_value_lower_l,
    xueya_low_warning_value_lower_h,
    xueya_low_value_lower,
    xueya_low_value_higher,
    xueya_low_warning_value_higher_l,
    xueya_low_warning_value_higher_h,
    xueya_low_alarm_value_higher,
    xueya_high_alarm_value_lower,
    xueya_high_warning_value_lower_l,
    xueya_high_warning_value_lower_h,
    xueya_high_value_lower,
    xueya_high_value_higher,
    xueya_high_warning_value_higher_l,
    xueya_high_warning_value_higher_h,
    xueya_high_alarm_value_higher,
    xueyang_value_lower,
    xueyang_value_higher,
    xueyang_warning_value_lower_l,
    xueyang_warning_value_lower_h,
    xueyang_warning_value_higher_l,
    xueyang_warning_value_higher_h,
    xueyang_alarm_value_lower,
    xueyang_alarm_value_higher,
    tiwen_warning_lv,
    tiwen_alarm_lv,
    xinlv_warning_lv,
    xinlv_alarm_lv,
    xueya_warning_lv,
    xueya_alarm_lv,
    xueyang_warning_lv,
    xueyang_alarm_lv,
) => qspost('/Index/Save/saveWarningValue', {
    tiwen_value_lower,
    tiwen_value_higher,
    tiwen_warning_value_lower_l,
    tiwen_warning_value_lower_h,
    tiwen_warning_value_higher_l,
    tiwen_warning_value_higher_h,
    tiwen_alarm_value_lower,
    tiwen_alarm_value_higher,
    xinlv_value_lower,
    xinlv_value_higher,
    xinlv_warning_value_lower_l,
    xinlv_warning_value_lower_h,
    xinlv_warning_value_higher_l,
    xinlv_warning_value_higher_h,
    xinlv_alarm_value_lower,
    xinlv_alarm_value_higher,
    xueya_low_alarm_value_lower,
    xueya_low_warning_value_lower_l,
    xueya_low_warning_value_lower_h,
    xueya_low_value_lower,
    xueya_low_value_higher,
    xueya_low_warning_value_higher_l,
    xueya_low_warning_value_higher_h,
    xueya_low_alarm_value_higher,
    xueya_high_alarm_value_lower,
    xueya_high_warning_value_lower_l,
    xueya_high_warning_value_lower_h,
    xueya_high_value_lower,
    xueya_high_value_higher,
    xueya_high_warning_value_higher_l,
    xueya_high_warning_value_higher_h,
    xueya_high_alarm_value_higher,
    xueyang_value_lower,
    xueyang_value_higher,
    xueyang_warning_value_lower_l,
    xueyang_warning_value_lower_h,
    xueyang_warning_value_higher_l,
    xueyang_warning_value_higher_h,
    xueyang_alarm_value_lower,
    xueyang_alarm_value_higher,
    tiwen_warning_lv,
    tiwen_alarm_lv,
    xinlv_warning_lv,
    xinlv_alarm_lv,
    xueya_warning_lv,
    xueya_alarm_lv,
    xueyang_warning_lv,
    xueyang_alarm_lv,
})





/*
 *问题列表
 * @constructor jack
 * */
export const getQuestionList = (page,pageSize) => qspost('/Index/Save/getQuestionList', {page,pageSize})

/*
 *问题-- 删除
 * @constructor jack
 * */
export const getQuestionDetails = (id) => qspost('/Index/Save/getQuestionDetails', {id})


/*
 *问题新增/修改
 * @constructor jack
 * */
export const saveQuestion = (title,image,content,id) => qspost('/Index/Save/saveQuestion', {title,image,content,id})


/*
 *问题-- 删除
 * @constructor jack
 * */
export const delQuestion = (id) => qspost('/Index/Save/delQuestion', {id})




